/* eslint-disable no-use-before-define */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable array-callback-return */
/* eslint-disable no-debugger */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-no-script-url */
/* eslint-disable no-script-url */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable max-len */
import React, { useState, useEffect, useRef } from 'react';
import { motion } from 'framer-motion';
import moment from 'moment';
import { Calendar } from 'react-calendar';
import { createUrl } from '../../redux/helper/CreateQuery';

function FilterModal({
    setfilter, threePL, territaryList, handleFiletr, selected, setselected,
}) {
    const currentDate = moment(new Date()).format('YYYY/MM/DD');
    const ref = useRef();
    const ref1 = useRef();

    const toggleState = {
        start_date: false,
        end_date: false,
        offer_type: false,
        type: false,
    };

    const AddToSelectValue = (item, type) => {
        const arr = [...selected[type]];
        const index = arr.indexOf(item);
        if (index === -1) {
            arr.push(item);
        } else {
            arr.splice(index, 1);
        }
        setselected((prevState) => ({
            ...prevState,
            [type]: arr,
        }));
    };

    const generateUrl = (val) => {
        let final = '';
        Object.keys(selected).map((key) => {
            switch (key) {
            case 'type':
                if (selected[key].length > 0) {
                    final += `&ATTRIBUTE1=${createUrl(selected[key])}`;
                }
                break;
            case 'status':
                if (selected[key].length !== 0) {
                    final += `&FALCON_LOGIN_STATUS=${selected.status}`;
                }
                break;
            default: break;
            }
        });
        if (val === undefined) {
            handleFiletr(final);
        }
        return final;
    };
    return (
        <div
            className="modal-dialog modal-dialog-centered relative max-w-[650px] pointer-events-none mt-0 mr-0 mb-0 h-full shadow-4xl bg-[#ffffff]"
        >
            <div
                className="modal-content border-none relative flex flex-col w-full pointer-events-auto bg-clip-padding outline-none text-current h-full"
            >
                <img
                    className="p-2 rounded-full cursor-pointer absolute top-4 right-4"
                    src="images/Component158–2.svg"
                    alt="close-icon"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    onClick={() => setfilter(false)}
                />
                <div className="pt-[64px] pb-5 bg-[#ffffff]">
                    <div className="pl-[60px] sticky top-0 left-0 z-10 bg-[#FFFFFF]">
                        <div className="flex justify-between pr-5 items-center w-full">
                            <h2 className="text-xl font-bold text-[#555259]">
                                Filter (s)
                            </h2>
                            <div>
                                {generateUrl('check').length > 0 && (
                                    <p
                                        className="text-base text-[#555259] font-bold cursor-pointer pr-10"
                                        onClick={() => {
                                            setselected({
                                                type: [],
                                                status: '',
                                            });
                                        }}
                                    >
                                        Clear
                                        {' '}

                                    </p>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="px-14 bg-[#FFFFFF]">
                        <div className="mt-6 bg-[#F5F5FA] rounded-md px-2 pt-6 relative pb-6">
                            <div className="relative">
                                <h5 className="text-base font-semibold text-[#555259]">Type</h5>
                                <div className="px-1 mt-4">

                                    <div className="relative checkbox custom-checkbox custom-checkbox2 custom-checkbox3 custom-checkbox3 flex items-center">
                                        <input type="checkbox" id="checkbox-1414" checked={selected.type.includes('Customer')} onChange={() => AddToSelectValue('Customer', 'type')} />
                                        <label htmlFor="checkbox-1414" className="pl-3 text-base font-normal text-[#555259] cursor-pointer">Customer</label>
                                    </div>
                                </div>
                                <div className="px-1 mt-2.5">
                                    <div className="relative checkbox custom-checkbox custom-checkbox2 custom-checkbox3 custom-checkbox3 flex items-center">
                                        <input type="checkbox" id="checkbox-1314" checked={selected.type.includes('Distributor')} onChange={() => AddToSelectValue('Distributor', 'type')} />
                                        <label htmlFor="checkbox-1314" className="pl-3 text-base font-normal text-[#555259] cursor-pointer">Distributor</label>
                                    </div>
                                </div>
                            </div>
                            <div className="mt-[18px]">
                                <h5 className="text-base font-semibold text-[#555259]">Status</h5>
                                <div className="px-1 mt-4">
                                    <div className="relative checkbox custom-checkbox custom-checkbox2 custom-checkbox3 custom-checkbox3 flex items-center">
                                        <input type="checkbox" id="checkbox-1014" checked={selected.status.includes('A')} onChange={() => AddToSelectValue('A', 'status')} />
                                        <label htmlFor="checkbox-1014" className="pl-3 text-base font-normal text-[#555259] cursor-pointer">Active</label>
                                    </div>
                                </div>
                                <div className="px-1 mt-2.5">
                                    <div className="relative checkbox custom-checkbox custom-checkbox2 custom-checkbox3 custom-checkbox3 flex items-center">
                                        <input type="checkbox" id="checkbox-11014" checked={selected.status.includes('I')} onChange={() => AddToSelectValue('I', 'status')} />
                                        <label htmlFor="checkbox-11014" className="pl-3 text-base font-normal text-[#555259] cursor-pointer">Inactive</label>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <motion.button
                            animate={{ y: 10 }}
                            transition={{ delay: 1 }}
                            type="button"
                            className="mt-[22px] text-lg font-semibold text-[#FFFFFF] w-full h-[52px] rounded-[16px] bg-[#555259] mb-5"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            onClick={() => generateUrl()}
                        >
                            Apply Filter(s)
                        </motion.button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default FilterModal;
